import { BuyerDetail as BuyerDetailPage } from 'ui/components/agent/patterns/BuyerDetail/BuyerDetail';

/**
 * 買い手企業詳細
 */
export const BuyerDetail: React.FC = () => {
    return <BuyerDetailPage />;
};
